import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import ApiUrls from "../../helpers/urls/ApiUrls";
import AppConfig from "../../helpers/constants/AppConfig";
import api from "../../helpers/api/Api";
import PieChart from "../Charts/PieChart";
import LoadingProgress from "../LoadingProgress";
import "./cacheUsePie.css";
import {bTh} from "../../helpers/functions/report-table";

function CacheUsePie({ graphData }) {
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState();

  useEffect(() => {
    if (graphData?.ip) {
      getGraph();
    }
  }, [graphData]);

  const getGraph = () => {
    setLoading(true);

    const fd = new FormData();
    fd.append("ip", graphData.ip);
    fd.append("item", "cacheuse");
    fd.append("period", "day");
    fd.append("domainid", graphData.domainId);

    api.post(ApiUrls.reports.getGraph, fd)
       .then((response) => {
         setData(response.data);
         setLoading(false);
       })
       .catch((error) => {
         setLoading(false);
       });
  }

  const setData = (res) => {
    let total;
    const labels = ["مصرف کش", "باقیمانده"], data = [];

    const size = res.cachesize[0];
    switch (res.cachesize[1]) {
      case "M":
        total = Math.pow(10, 6) * size;
        return;
      case "G":
        total = Math.pow(10, 9) * size;
    }

    data[0] = res.cacheuse;
    data[1] = total - res.cacheuse;

    setChartData({ labels, data, total });
  }

  return (
     <Grid item md={8} xs={12} className="pie-chart-modal">
       {loading
          ? <LoadingProgress color={AppConfig.color} />
          : <PieChart
             id={graphData.id}
             chart={{
               labels: chartData?.labels,
               datasets: chartData?.data,
               rtl: true,
               tooltipCallback: {
                 label: function(context) {
                   let label = `${context.label}: `;
                   label += `${((context.raw/chartData?.total)*100).toFixed(1)}%`;
                   return label;
                 }
               },
               legendFilter: function(legendItem, data) {
                 const label = legendItem.text;
                 const labelIndex = data.labels.findIndex((l) => l === label);
                 const qtd = data.datasets[0].data[labelIndex];
                 legendItem.text = `${legendItem.text}: ${bTh(qtd, "GB")}`;
                 return true;
               }
             }}
          />
       }
     </Grid>
  );
}

export default CacheUsePie;
